import { palette } from "../../config";

export default theme => ({
	"@global": {
		// "canvas": {
		//   width: "70vw",
		//   height: "auto",
		//   margin: "auto"
		// },
		"#proxyTrigger": {
			width: "auto",
			height: "100vh",
			backgroundRepeat: "no-repeat",
			backgroundPosition: "center center",
			backgroundSize: "cover",
			backgroundImage: "url(./data/index.jpg)"
		},
		"#target": {
			width: "auto",
			height: "calc(100vh);",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			background: "black",
			"& canvas": {
				alignSelf: "center",
				width: "auto",
				height: "100%"
			}
		}
	},
	root: {
		width: "auto",
		height: "100%",
		alignContent: "center",
		alignItems: "center",
		textAlign: "center",
		display: "flex",
		justifyContent: "center",
		overflow: "hidden",
		"&.rootLCI": {
			height: "calc(100vh)",
			[theme.breakpoints.down("sm")]: {
				height: "auto",
				width: "100vw"
			}
		}
	},
	canvas: {
		width: "auto",
		height: "100vh",
		[theme.breakpoints.down("sm")]: {
			height: "auto",
			width: "100vw"
		}
	},
	arrowsContainer: {
		position: "absolute",
		bottom: "150px",
		transform: "rotate(180deg)",
		left: "calc(50% - 2.875rem)",
		".rootLCI &": {
			left: "38%"
		},
		[theme.breakpoints.down("sm")]: {
			left: "calc(50% - 3.375rem)",
			bottom: "100px"
		}
	},
	arrows: {
		minWidth: "auto",
		marginRight: theme.spacing.unit,
		borderRadius: "0px",
		border: "1px solid rgba(230, 0, 126, 1)",
		padding: "1px",
		backgroundClip: "content-box",
		backgroundColor: "rgba(230, 0, 126, 1)",
		width: "54px",
		height: "54px",
		[theme.breakpoints.down("sm")]: {
			width: "3rem",
			height: "3rem",
			visibility: "hidden"
		}
	},
	arrowLeft: {
		marginRight: theme.spacing.unit * 2,
		[theme.breakpoints.down("sm")]: {
			marginRight: theme.spacing.unit
		}
	},
	arrowRight: {
		marginRight: theme.spacing.unit * 2,
		[theme.breakpoints.down("sm")]: {
			marginRight: theme.spacing.unit
		}
	},
	arrowIcon: {
		width: "40px",
		height: "40px",
		fill: "rgb(255,255,255)",
		background: theme.palette.primary.background,
		[theme.breakpoints.down("sm")]: {
			width: "1rem",
			height: "1rem"
		}
	},
	eyeContainer:{
		minWidth: "auto",
		marginRight: theme.spacing.unit,
		borderRadius: "0px",
		padding: "1px",
		backgroundClip: "content-box",
		backgroundColor: "rgba(230, 0, 126, 1)",
		width: "54px",
		height: "54px",
		boxShadow: "unset",
		top: "2rem",
		right: "10rem",
		position: "absolute",
		[theme.breakpoints.down("sm")]: {
			width: "3rem",
			height: "3rem",
			visibility: "hidden"
		}
	},
	eyeIco:{
		width: "21px",
		height: "21px",
		fill: "rgb(255,255,255)",
		background: theme.palette.primary.background,
		[theme.breakpoints.down("sm")]: {
			width: "1rem",
			height: "1rem"
		}
	},
	eye: {
		width: "184px",
		height: "35px",
		fontSize: "12px",
		fontWeight: "600",
		fontFamily: "Inter",

		[theme.breakpoints.down("sm")]: {
			left: "calc(50% + 10rem)",
			bottom: "100px"
		}
	}
});
